import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import useClickOutside from "../../../helpers/clickOutside";
import { deletePost } from "../../../functions/post";
import "./style.css";

export default function FeedPostMenu({ post, onEdit, onPostDeleted }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const menuRef = useRef(null);

  const isOwner = post?.user?._id === user?.id || post?.user === user?.id;

  useClickOutside(menuRef, () => {
    setShowMenu(false);
    setShowDeleteConfirm(false);
  });

  const handleDelete = async () => {
    if (deleting) return;
    setDeleting(true);
    try {
      const result = await deletePost(post._id, user.token);
      if (result?.status === "ok") {
        onPostDeleted?.(post._id);
      }
    } catch (error) {
      console.error("Erro ao excluir post:", error);
    }
    setDeleting(false);
    setShowDeleteConfirm(false);
    setShowMenu(false);
  };

  if (!isOwner) return null;

  return (
    <div className="feed_post_menu_container" ref={menuRef}>
      <button
        className="feed_post_menu_btn"
        onClick={(e) => {
          e.stopPropagation();
          setShowMenu(!showMenu);
        }}
        title="Mais opcoes"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>

      {showMenu && !showDeleteConfirm && (
        <div className="feed_post_menu_dropdown">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(post);
              setShowMenu(false);
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
            </svg>
            Editar
          </button>
          <button
            className="delete_btn"
            onClick={(e) => {
              e.stopPropagation();
              setShowDeleteConfirm(true);
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
            </svg>
            Excluir
          </button>
        </div>
      )}

      {showDeleteConfirm && (
        <div className="feed_delete_confirm">
          <p>Tem certeza que deseja excluir este post?</p>
          <div className="feed_delete_actions">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirm(false);
              }}
              disabled={deleting}
            >
              Cancelar
            </button>
            <button
              className="confirm_delete"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete();
              }}
              disabled={deleting}
            >
              {deleting ? "Excluindo..." : "Excluir"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
